import { render, staticRenderFns } from "./SkeletonBox.vue?vue&type=template&id=7f796f52&"
import script from "./SkeletonBox.vue?vue&type=script&lang=ts&"
export * from "./SkeletonBox.vue?vue&type=script&lang=ts&"
import style0 from "./SkeletonBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports